import { Typography, Grid, Alert, Snackbar } from "@mui/material";
import Modal from "../../../../../components/Modal/Modal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCompanyPickUpRequestVoucherType } from "../../../../../hooks/useCompanyPickUpRequestVoucherTypes";
import { useState } from "react";
import { deleteAdditionalPickUpRequestCharge } from "../../../../../hooks/useAdditionalPickUpRequestCharges";
import { deleteOrganizationFavouriteLocation } from "../../../../../hooks/useOrganizationFavouriteLocations";

const OrganizationFavouriteLocationDeleteModal = ({
  accessToken,
  organizationId,
  open,
  setOpen,
  selectedOrganizationFavouriteLocation,
  setSelectedOrganizationFavouriteLocation,
}: {
  accessToken: string;
  organizationId?: string;
  selectedOrganizationFavouriteLocation: any;
  setSelectedOrganizationFavouriteLocation: any;
  open: boolean;
  setOpen: any;
}) => {
  const queryClient = useQueryClient();
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const {
    mutate: handleDeleteOrganizationFavouriteLocation,
    isLoading: isDeleteOrganizationFavouriteLocationLoading,
  } = useMutation({
    mutationFn: deleteOrganizationFavouriteLocation,
    onSuccess: async (data) => {
      // resetFields();
      await queryClient.cancelQueries({
        queryKey: ["organization-favourite-locations", organizationId],
      });

      await queryClient.cancelQueries({
        queryKey: ["organization-favourite-locations", organizationId],
      });

      await queryClient.invalidateQueries({
        queryKey: ["organization-favourite-locations", organizationId],
      });
      setOpen(false);
      setSelectedOrganizationFavouriteLocation(null);
      setShowSuccess(true);
    },
    onError: async (error: any) => {
      console.log("error adding new payment method", error);
      setSubmitError(error);
    },
  });

  const handleSubmit = () => {
    handleDeleteOrganizationFavouriteLocation({
      accessToken,
      organizationFavouriteLocationId:
        selectedOrganizationFavouriteLocation?.id,
    });
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrganizationFavouriteLocation(null);
  };
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={Boolean(submitError)}
        autoHideDuration={6000}
        onClose={(reason) => {
          console.log("reason", reason);
          setSubmitError("");
        }}
      >
        <Alert
          onClose={() => {
            setSubmitError("");
          }}
          severity="error"
          sx={{ width: "100%" }}
        >
          {submitError}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={showSuccess}
        autoHideDuration={6000}
        onClose={() => {
          setShowSuccess(false);
        }}
      >
        <Alert
          onClose={() => {
            setShowSuccess(false);
          }}
          severity="success"
          sx={{ width: "100%" }}
        >
          Favourite location deleted
        </Alert>
      </Snackbar>
      <Modal
        open={open}
        loading={isDeleteOrganizationFavouriteLocationLoading}
        onSubmit={handleSubmit}
        onCancel={handleClose}
        handleClose={handleClose}
        title={"Confirm favourite location deletion"}
        submitButtonLabel="Delete"
      >
        <Grid item>
          <Typography>
            Are you sure you want to delete this favourite location?{" "}
            <Typography fontWeight={700} component="span">
              This action is permanent and can result in data loss.
            </Typography>
          </Typography>
        </Grid>
      </Modal>
    </>
  );
};

export default OrganizationFavouriteLocationDeleteModal;
